import { http } from 'utils'
import { SET_SETTINGS, SET_SETTINGS_PROPERTY } from 'vx/mutations'
import { set } from 'lodash'
// Settings state.
const state = {
  settings: {
    public_job_cutoff: null
  }
}

// User state getters.
const getters = {}

// user actions.
const actions = {
  /**
   * Get all settings.
   *
   * @return Promise
   */
  getSettings ({ commit }, id) {
    return http.get(`settings`).then(response => {
      commit(SET_SETTINGS, response.data)

      return response
    })
  },

  /**
   * Update settings.
   *
   * @return Promise
   */
  updateSettings ({ commit }, payload) {
    return http.put(`settings`, payload).then(response => {
      return response
    })
  }
}

// Setting state mutations.
const mutations = {
  [SET_SETTINGS] (state, settings) {
    state.settings = settings
  },

  [SET_SETTINGS_PROPERTY] (state, { property, value }) {
    set(state.settings, property, value)
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/settings.js